import Cookies from 'js-cookie'

export const form = {
  namespaced: true,
  state: {
    usLocations: [],
    usCities: [],
    usStates: [],
    practiceAreas: [],
    marketingCompanies: [],
    bulkFormsEnqueued: false,
    loadingData: false,
    blacklistedDomains: []
  },
  mutations: {
    setUsLocations (state, list) {
      state.usLocations = list
    },
    setUsCities (state, list) {
      state.usCities = []
      list.forEach(el => {
        const pieces = el.split(',')
        const city = pieces[0]
        state.usCities.push(city)
      })
    },
    setUsStates (state, list) {
      state.usStates = []
    },
    setPracticeAreas (state, areas) {
      state.practiceAreas = areas
    },
    setBulkFormsEnqueued (state, bool) {
      state.bulkFormsEnqueued = bool
    },
    setMarketingCompanies (state, companies) {
      state.marketingCompanies = companies
    },
    setLoadingData (state, bool) {
      state.loadingData = bool
    },
    setBlacklistedDomains (state, domains) {
      state.blacklistedDomains = domains
    }
  },
  actions: {
    setLoadingData ({ commit }, bool) {
      commit('setLoadingData', bool)
    },
    clearData ({ commit }) {
      commit('setMarketingCompanies', [])
      commit('setPracticeAreas', [])
      commit('setUsLocations', [])
      commit('setUsCities', [])
      commit('setUsStates', [])
      commit('setBlacklistedDomains', [])
    },
    async setData ({ commit, state, rootState }) {
      const client = this._vm.$arc
      const isCurrent = () => this._vm.$arc === client && rootState.auth.authReady
      if (!client || !isCurrent() || Cookies.get('_.arc_score.isGuest') === 'true') return
      commit('setLoadingData', true)
      try {
        const hasCanadianLocations = state.usLocations.some(location => location.includes(',Canada'))
        if (!state.usLocations.length || !state.blacklistedDomains.length || !hasCanadianLocations) {
          const [locations, blacklist] = await Promise.all([
            client.get('dfs/locations'),
            client.get('domains/blacklist')
          ])
          if (!isCurrent()) return
          commit('setUsLocations', (locations.data.locations || []).map(location => location.name))
          commit('setBlacklistedDomains', (blacklist.data.domains || []).map(domain => domain.name))
        }
        const { data } = await client.get('practice_areas')
        if (!isCurrent()) return
        commit('setPracticeAreas', (data.practice_areas || []).map(area => area.name))
      } finally {
        if (isCurrent()) commit('setLoadingData', false)
      }
    },
    setBulkFormsEnqueued ({ commit }, bool) {
      commit('setBulkFormsEnqueued', bool)
    }
  },
  getters: {
    allUsLocations: (state) => state.usLocations,
    allUsCities: (state) => state.usCities,
    allUsStates: (state) => state.usStates,
    allPracticeAreas: (state) => state.practiceAreas,
    getBulkFormsStatus: (state) => state.bulkFormsEnqueued,
    allBlacklistedDomains: (state) => state.blacklistedDomains
  }
}
